"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TTC_GRM_Service = void 0;
const generate_contact_1 = require("../lib/contacts/generate-contact");
const generate_contacts_1 = require("../lib/contacts/generate-contacts");
const generate_alert_1 = require("../lib/alerts/generate-alert");
const generate_mnemonic_1 = require("../lib/mnemonics/generate-mnemonic");
const _ = __importStar(require("lodash"));
const utils_1 = require("../utils");
const initialStore = {
    contacts: new Map(),
    alerts: new Map(),
    mnemonics: new Map(),
};
class TTC_GRM_Service {
    _data = initialStore;
    _subscribers = new Set();
    _contactOptions = {};
    _interval;
    _intervalId = undefined;
    _limit;
    constructor(options) {
        this.transformData = this.transformData.bind(this);
        this._contactOptions = {
            alertsPercentage: options?.alertsPercentage,
            dateRef: options?.dateRef,
            daysRange: options?.daysRange,
            secondAlertPercentage: options?.secondAlertPercentage,
            subsystemOptions: options?.subsystemOptions,
        };
        this._interval = options?.interval || 0;
        this._limit = options?.limit || 200;
        if (options?.initial && this._data.contacts.size === 0) {
            this._generateInitialData(options.initial);
        }
    }
    _generateInitialData = (initial) => {
        const contactsArray = (0, generate_contacts_1.generateContacts)(initial, this._contactOptions);
        contactsArray.forEach((contact) => this._data.contacts.set(contact.id, contact));
        this._publish();
    };
    _publish = () => {
        const newAlerts = new Map();
        const newMnemonics = new Map();
        const allContacts = Array.from(this._data.contacts.values());
        const alertsArray = allContacts.flatMap((contact) => contact.alerts);
        alertsArray.forEach((alert) => newAlerts.set(alert.id, alert));
        const mnemonicsArray = allContacts.flatMap((contact) => contact.mnemonics);
        mnemonicsArray.forEach((mnemonic) => newMnemonics.set(mnemonic.id, mnemonic));
        this._data.contacts = structuredClone(this._data.contacts);
        this._data.alerts = newAlerts;
        this._data.mnemonics = newMnemonics;
        this._subscribers.forEach((callback) => {
            callback(this._data);
        });
    };
    subscribe = (callback) => {
        // sets interval for adding contacts on first subscribe
        if (this._subscribers.size === 0) {
            this._intervalId = this._interval
                ? setInterval(this.addContact.bind(this), 1000 * this._interval)
                : undefined;
        }
        this._subscribers.add(callback);
        this._publish();
        return () => {
            this._subscribers.delete(callback);
            if (this._subscribers.size < 1) {
                clearInterval(this._intervalId);
            }
        };
    };
    getSnapshot = () => {
        return this._data;
    };
    transformData(mappedData) {
        const firstValue = [...mappedData.values()][0];
        if (!firstValue) {
            return {
                dataArray: [],
                dataById: {},
                dataIds: [],
            };
        }
        if (firstValue.type === 'contact') {
            return this._buildStructuredData(mappedData);
        }
        else if (firstValue.type === 'alert') {
            return this._buildStructuredData(mappedData);
        }
        else if (firstValue.type === 'mnemonic') {
            return this._buildStructuredData(mappedData);
        }
    }
    addContact = (options = this._contactOptions) => {
        if (this._data.contacts.size >= this._limit) {
            console.info('contact limit reached');
            clearInterval(this._intervalId);
            return;
        }
        const index = this._data.contacts.size - 1;
        const addedContact = (0, generate_contact_1.generateContact)(index, options);
        this._data.contacts.set(addedContact.id, addedContact);
        this._publish();
        return addedContact;
    };
    addAlert = (contactId, options) => {
        const newAlert = (0, generate_alert_1.generateAlert)({ contactRefId: contactId, ...options });
        const currentContact = this._data.contacts.get(contactId);
        if (!currentContact)
            throw new Error(`Contact with id ${contactId} does not exist`);
        this.modifyContact({
            id: contactId,
            alerts: [...currentContact.alerts, newAlert],
        });
        return newAlert;
    };
    addMnemonic = (contactId, options) => {
        const newMnemonic = (0, generate_mnemonic_1.generateMnemonic)({
            contactRefId: contactId,
            ...options,
        });
        const currentContact = this._data.contacts.get(contactId);
        if (!currentContact)
            throw new Error(`Contact with id ${contactId} does not exist`);
        this.modifyContact({
            id: contactId,
            mnemonics: [...currentContact.mnemonics, newMnemonic],
        });
        return newMnemonic;
    };
    modifyContact = (params) => {
        const currentContact = this._data.contacts.get(params.id);
        if (!currentContact)
            throw new Error(`Contact with id ${params.id} does not exist`);
        const modifiedContact = { ...currentContact, ...params };
        if (params.subsystems) {
            modifiedContact.mnemonics = (0, utils_1.getSubsystemMnemonics)(params.subsystems);
        }
        this._data.contacts.set(params.id, modifiedContact);
        this._publish();
        return modifiedContact;
    };
    modifyAlert = (params) => {
        const currentContact = this._data.contacts.get(params.contactRefId);
        if (!currentContact)
            throw new Error(`Contact with id ${params.contactRefId} does not exist`);
        const currentAlert = currentContact?.alerts.find((alert) => alert.id === params.id);
        if (!currentAlert)
            throw new Error(`Alert with id ${params.id} does not exist`);
        const alertIndex = currentContact?.alerts.indexOf(currentAlert);
        const modifiedAlert = { ...currentAlert, ...params };
        currentContact.alerts.splice(alertIndex, 1, modifiedAlert);
        this._publish();
        return modifiedAlert;
    };
    modifyMnemonic = (params) => {
        const currentContact = this._data.contacts.get(params.contactRefId);
        if (!currentContact)
            throw new Error(`Contact with id ${params.contactRefId} does not exist`);
        const mnemonicIndex = currentContact?.mnemonics.findIndex((mnemonic) => mnemonic.id === params.id);
        const modifiedMnemonic = {
            ...currentContact.mnemonics[mnemonicIndex],
            ...params,
        };
        const modifiedSubsystems = (0, utils_1.updateSubsystemWithMnemonic)(currentContact, params);
        this.modifyContact({
            id: currentContact.id,
            subsystems: modifiedSubsystems,
        });
        return modifiedMnemonic;
    };
    modifyAllContacts = (params) => {
        this._data.contacts.forEach((contact, contactId) => {
            const modifiedContact = { ...contact, ...params };
            if (params.subsystems) {
                modifiedContact.mnemonics = (0, utils_1.getSubsystemMnemonics)(params.subsystems);
            }
            this._data.contacts.set(contactId, modifiedContact);
        });
        this._publish();
        return `Successfully modified all contacts`;
    };
    modifyAllAlerts = (params) => {
        this._data.contacts.forEach((contact, contactId) => {
            const mappedAlerts = contact.alerts.map((alert) => {
                return { ...alert, ...params };
            });
            this._data.contacts.set(contactId, { ...contact, alerts: mappedAlerts });
        });
        this._publish();
        return `Successfully modified all alerts`;
    };
    modifyAllMnemonics = (params) => {
        this._data.contacts.forEach((contact, contactId) => {
            const updateMnemonicOnSubsystem = (value) => {
                if (value.type === 'mnemonic') {
                    return { ...value, ...params };
                }
            };
            const modifiedSubsystems = _.cloneDeepWith(contact.subsystems, updateMnemonicOnSubsystem);
            this.modifyContact({ ...contact, subsystems: modifiedSubsystems });
        });
        return `Successfully modified all mnemonics`;
    };
    deleteContact = (id) => {
        this._data.contacts.delete(id);
        this._publish();
        return `Successfully deleted contact: ${id}`;
    };
    deleteAlert = (contactRefId, alertId) => {
        const currentContact = this._data.contacts.get(contactRefId);
        if (!currentContact)
            return `Contact with id ${contactRefId} does not exist`;
        const modifiedAlerts = currentContact.alerts.filter((alert) => alert.id !== alertId);
        this.modifyContact({ id: currentContact.id, alerts: modifiedAlerts });
        return `Successfully deleted alert: ${alertId}`;
    };
    deleteMnemonic = (contactRefId, mnemonicId) => {
        const currentContact = this._data.contacts.get(contactRefId);
        if (!currentContact)
            return `Contact with id ${contactRefId} does not exist`;
        const modifiedMnemonics = currentContact.mnemonics.filter((mnemonic) => mnemonic.id !== mnemonicId);
        this.modifyContact({ id: currentContact.id, mnemonics: modifiedMnemonics });
        return `Successfully deleted mnemonic: ${mnemonicId}`;
    };
    deleteContactsWithProp = (property, value) => {
        this._data.contacts.forEach((contact, contactId) => {
            if (contact[property] === value)
                this._data.contacts.delete(contactId);
        });
        this._publish();
        return `Successfully deleted all contacts with ${property} of ${value}`;
    };
    deleteAlertsWithProp = (property, value) => {
        const contacts = this._data.contacts;
        contacts.forEach((contact, contactId) => {
            const filteredAlerts = contact.alerts.filter((alert) => alert[property] !== value);
            contacts.set(contactId, {
                ...contact,
                alerts: filteredAlerts,
            });
        });
        this._publish();
        return `Successfully deleted all alerts with ${property} of ${value}`;
    };
    deleteMnemonicsWithProp = (property, value) => {
        this._data.contacts.forEach((contact, contactId) => {
            const filteredMnemonics = contact.mnemonics.filter((mnemonic) => mnemonic[property] !== value);
            this._data.contacts.set(contactId, {
                ...contact,
                mnemonics: filteredMnemonics,
            });
        });
        this._publish();
        return `Successfully deleted all mnemonics with ${property} of ${value}`;
    };
    allContactsHaveProp = (property, value) => {
        const { dataArray } = this.transformData(this._data.contacts);
        return dataArray.every((data) => data[property] === value);
    };
    allAlertsHaveProp = (property, value) => {
        const { dataArray } = this.transformData(this._data.alerts);
        return dataArray.every((data) => data[property] === value);
    };
    allMnemonicsHaveProp = (property, value) => {
        const { dataArray } = this.transformData(this._data.mnemonics);
        return dataArray.every((data) => data[property] === value);
    };
    anyContactsHaveProp = (property, value) => {
        const { dataArray } = this.transformData(this._data.contacts);
        return dataArray.some((data) => data[property] === value);
    };
    anyAlertsHaveProp = (property, value) => {
        const { dataArray } = this.transformData(this._data.alerts);
        return dataArray.some((data) => data[property] === value);
    };
    anyMnemonicsHaveProp = (property, value) => {
        const { dataArray } = this.transformData(this._data.mnemonics);
        return dataArray.some((data) => data[property] === value);
    };
    _buildStructuredData = (mappedData) => {
        const dataArray = [...mappedData.values()];
        const dataById = Object.fromEntries(mappedData.entries());
        const dataIds = [...mappedData.keys()];
        return { dataArray, dataById, dataIds };
    };
}
exports.TTC_GRM_Service = TTC_GRM_Service;
